import { ReactNode } from "react";

/**
 * Campos de solo lectura de las pantallas de detalle.
 *
 * Misma jerarquía que <FormField> (§3.3): etiqueta Body Small gris arriba y el
 * valor en Body abajo, con el mismo tamaño y peso en todos los campos. Antes
 * cada detalle mezclaba valores con y sin `text-lg`, y unos se leían más
 * "en negrita" que otros.
 */
export const DetailGrid = ({ children }: { children: ReactNode }) => (
  <div
    style={{
      display: "grid",
      // Hasta 3 columnas iguales; con auto-fit una sección de 2 campos los
      // reparte mitad y mitad en vez de dejar un tercio vacío a la derecha.
      gridTemplateColumns:
        "repeat(auto-fit, minmax(max(200px, calc((100% - 2 * var(--space-18)) / 3)), 1fr))",
      gap: "var(--space-18)",
    }}
  >
    {children}
  </div>
);

interface DetailFieldProps {
  label: string;
  children: ReactNode;
  /** Ocupa la fila entera (ej. una lista de tarjetas o una tabla). */
  wide?: boolean;
}

export const DetailField = ({ label, children, wide = false }: DetailFieldProps) => (
  <div
    className="flex flex-column"
    style={{ gap: "var(--space-6)", gridColumn: wide ? "1 / -1" : undefined }}
  >
    <span className="text-sm font-semibold text-600">{label}</span>
    <div className="line-height-3" style={{ overflowWrap: "anywhere" }}>
      {children}
    </div>
  </div>
);

/** Valor vacío ("—", "Sin límite", "Todos"): en gris para no leerse como dato. */
export const DetailEmpty = ({ children = "—" }: { children?: ReactNode }) => (
  <span className="text-color-secondary">{children}</span>
);
